import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToasterService } from 'src/app/services/toaster.service';

import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-edit-scrubber-points',
  templateUrl: './edit-scrubber-points.component.html',
  styleUrls: ['./edit-scrubber-points.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditScrubberPointsComponent implements OnInit {  
  
  isOpen: boolean;
  headerName = 'Edit scrubber points'
  switchLng:boolean = false;
  maxLength:number = 500;
  maxLengths:number = 300;
  isTextError:boolean = false;
  ediScrubberPointsVal:string = 'editScrubberPointsVal_1';
  @Input() shipDetailsbasicinfo:any;
  @Input() scrubberPointDetails:any;
  @Output() getupdatePoolPoints = new EventEmitter();
  @Output() emitPoolPointsDetails = new EventEmitter();
  @Output() getupdateScrubberPoints = new EventEmitter();
  @Output() getScrubberPointLoaderEvent = new EventEmitter();
  @Output() errorScrubberPointLoaderEvent = new EventEmitter();
  selectedPoolPointsDateVal: any;
  poolPointsReason: string = '';
  selectedNewScrubberPointsDateVal: any = null;
  poolPointsNewReason: string = '';
  openEditScrubberPoints:boolean = false;
  poolPointsReasonError: boolean = false;
  newScrubberPointForm: UntypedFormGroup;
  private readonly decimalPattern = /^[1-9]\d*(?:\.\d{1,2})?$/;
  newScrubberPointVal: any = null;
  poolPointsNewReasonError: boolean = false;
  updatePoolPointsData: any;
  upComingScrubberDate: any;
  upComingScrubberReason: string = '';
  newUpcomingReason: string = '';
  selectedUpcomingDate: any;
  openDiscardPoolPoint: boolean = false;
  getFYdate: any;
  disableFYdate: any;
  vesselActivationDate: any;
  discardSuccess: boolean = false;
  updatePayload: { vslNumber: any; scrubberPoint: number; scrubberPointEffectiveFrom: string | null; scrubberPointReason: string; };
  scrubberPointsNewReason: string = '';
  scrubberPointsNewReasonError: boolean = false;
  selectedScrubberPointsDateVal: any;
  scrubberPointsReason: string = '';
  scrubberPointsReasonError: boolean = false;
  updateScrubberPointsData: any;
  discardScrubberSuccess: boolean = false;
  openDiscardScrubberPoint: boolean = false;
  discardScrubberPointData: any;
  showDiscardScrubberBanner: boolean = false;
  selectedUpcomingScrubberDate: any;
  newUpcomingScrubberReason: string = '';
  openRestoreScrubberPoint:boolean = false;
  pendingCalcScrubberDate: any;
  pendingCalcScrubberReason: string = '';
  pendingCalcScrubberReasonError: boolean = false;
  pendingCalcScrubberPointVal:any = null;
  revertScrubberPointData: any;
  noChangeScrubberReason: string = '';
  noChangeScrubberDate: any;
  showScrubberPointsErrorMsg: boolean = false;
  showScrubberPointsPendingErrorMsg: boolean = false;

  private readonly scrubberPointsRequiredMessages: Record<string, string> = {
    newScrubberPoints: 'New scrubber points are required.',
    pendingCalcScrubberPoints: 'Current scrubber points are required.',
  };
  private readonly scrubberPointsPatternMessage = 'Please enter a valid decimal input.';
 
  constructor(private vesselService:VesselsService, 
    private toasterService: ToasterService,
    private fb: UntypedFormBuilder,
    private datePipe: DatePipe,
   ) {
  }

  ngOnInit() {
   console.log(this.shipDetailsbasicinfo)
   this.newScrubberPointForm = this.fb.group({
    newScrubberPoints: ['', [Validators.required,Validators.pattern(this.decimalPattern)]],
    pendingCalcScrubberPoints :['', [Validators.required,Validators.pattern(this.decimalPattern)]],
    });
    this.newScrubberPointForm.valueChanges.pipe(debounceTime(1000),distinctUntilChanged()).subscribe((value:any) => {
    console.log(value)
      this.newScrubberPointVal = value;
      this.pendingCalcScrubberPointVal = value;
    })
  }   
  checkScrubberPointsValidation(){
    this.ediScrubberPointsVal = '';
    this.pendingCalcScrubberReason = '';
    this.pendingCalcScrubberDate = null;
    this.scrubberPointsNewReason = '';
    this.newUpcomingScrubberReason = '';
    this.selectedUpcomingScrubberDate = null;
    this.upComingScrubberDate = null;
    this.upComingScrubberReason = '';
    this.newScrubberPointForm.patchValue({
      newScrubberPoints: '',
      pendingCalcScrubberPoints:''
    });
    this.showScrubberPointsErrorMsg = false;
    this.showScrubberPointsPendingErrorMsg = false;
    this.newScrubberPointForm.markAsUntouched(); 
    this.newScrubberPointForm.markAsPristine()
    
  }
  scrubberPointsDeatilsSidePanelData(){
    this.openEditScrubberPoints = true;
    this.vesselActivationDate = this.scrubberPointDetails?.vesselActivationDate;
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate)
    if(this.scrubberPointDetails?.hasPreviousChange){
      if(this.scrubberPointDetails?.status === 'upcomingChange'){
        this.ediScrubberPointsVal = 'editScrubberPointsVal_3'
        this.newScrubberPointForm.patchValue({
          newScrubberPoints: this.formatScrubberPointsForInput(this.scrubberPointDetails?.upComingScrubberPoint)
        });
        this.upComingScrubberDate = this.scrubberPointDetails?.upcomingEffectiveDate;
        this.upComingScrubberReason = this.scrubberPointDetails?.upcomingReason ?? '';
        this.newUpcomingScrubberReason = this.upComingScrubberReason;
        this.selectedUpcomingScrubberDate = null;
        this.showDiscardScrubberBanner = true;
      }
      if(this.scrubberPointDetails?.status === 'pendingCalculation'){
        this.ediScrubberPointsVal = 'editScrubberPointsVal_4';
        this.newScrubberPointForm.patchValue({
          newScrubberPoints: '',
          pendingCalcScrubberPoints: this.formatScrubberPointsForInput(this.scrubberPointDetails?.currentScrubberPoint)
        });
        this.pendingCalcScrubberDate = this.scrubberPointDetails?.currentEffectiveDate;
        this.pendingCalcScrubberReason = this.scrubberPointDetails?.currentReason ?? '';
      }
      if(this.scrubberPointDetails?.status === 'noChange'){
        this.ediScrubberPointsVal = 'editScrubberPointsVal_1';
        this.noChangeScrubberDate = this.scrubberPointDetails?.currentEffectiveDate;
        this.noChangeScrubberReason = this.scrubberPointDetails?.currentReason;
        this.selectedScrubberPointsDateVal = this.scrubberPointDetails?.currentEffectiveDate;
        this.scrubberPointsReason = this.scrubberPointDetails?.currentReason;
      }
    }else{
      this.ediScrubberPointsVal = 'editScrubberPointsVal_1';
      this.noChangeScrubberDate = this.scrubberPointDetails?.currentEffectiveDate;
      this.noChangeScrubberReason = this.scrubberPointDetails?.currentReason;
      this.selectedScrubberPointsDateVal = this.scrubberPointDetails?.currentEffectiveDate;
      this.scrubberPointsReason = this.scrubberPointDetails?.currentReason;
    }
  }
  editScrubberPoints(){
    console.log(this.scrubberPointDetails)
    // this.callGetScrubberPointDetails();
   this.checkScrubberPointsValidation();
   this.scrubberPointsDeatilsSidePanelData();
  }
  callGetScrubberPointDetails(){
    this.checkScrubberPointsValidation()
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getScrubberPointDetails(input).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res.data.getScrubberPointDetails.success){
          this.scrubberPointDetails = res.data.getScrubberPointDetails.data;
          this.scrubberPointsDeatilsSidePanelData();
        }
        else{
          this.toasterService.openToast('Error', res.data.getPoolPointDetails.message);
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  changeScrubberPoints(){
    this.ediScrubberPointsVal = 'editScrubberPointsVal_2'
  }
  get minSelectableDate(): Date {
   
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }

  get scrubberPointsEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedScrubberPointsDateVal ?? this.noChangeScrubberDate);
  }

  get upcomingScrubberEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedUpcomingScrubberDate ?? this.upComingScrubberDate);
  }

  get pendingScrubberEffectiveDate(): Date | null {
    return this.toPickerDate(this.pendingCalcScrubberDate);
  }

  get upcomingScrubberReasonValue(): string {
    return this.newUpcomingScrubberReason || this.upComingScrubberReason || '';
  }

  private formatScrubberPointsForInput(value: unknown): string {
    return value === null || value === undefined || value === '' ? '' : String(value);
  }

  private toPickerDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const parsed = new Date(value as string);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  selectedScrubberPointsDate(e:any){
    this.selectedScrubberPointsDateVal = e;
    this.noChangeScrubberDate = null;
  }
  scrubberPointsfieldValue(event:any){
    this.scrubberPointsReason = event;
    this.noChangeScrubberReason = '';
    if(this.scrubberPointsReason.length >= 500){
      this.scrubberPointsReasonError = true;
    }else{
      this.scrubberPointsReasonError = false;
    }
  }
  selectedNewScrubberPointsDate(e:any){
    this.selectedNewScrubberPointsDateVal = e;
    console.log(e)
  }
  upComingScrubberPointsDate(e:any){
    this.selectedUpcomingScrubberDate = e;
    this.upComingScrubberDate = null;
  }
  upComingScrubberfieldValue(e:any){
    this.newUpcomingScrubberReason = e
    // this.newUpcomingReason=   e + this.upComingReason;
    this.upComingScrubberReason = ''
    console.log(this.newUpcomingScrubberReason)
  }
  newScrubberPointsfieldValue(e:any){
    this.scrubberPointsNewReason = e;
    if(this.scrubberPointsNewReason.length >= 500){
      this.scrubberPointsNewReasonError = true;
    }else{
      this.scrubberPointsNewReasonError = false;
    }
    

  }
  updateScrubberPoints(){
    
    this.getScrubberPointLoaderEvent.emit();
    let upComingScrubberDate = this.datePipe.transform(this.upComingScrubberDate,"yyyy-MM-dd");
    let selectedUpcomingScrubberDate = this.datePipe.transform(this.selectedUpcomingScrubberDate,"yyyy-MM-dd")
    let selectedNewScrubberPointsDateVal = this.datePipe.transform(this.selectedNewScrubberPointsDateVal,"yyyy-MM-dd")
    console.log(selectedNewScrubberPointsDateVal);
    console.log(selectedUpcomingScrubberDate);
    console.log(upComingScrubberDate);
   
    if(this.scrubberPointDetails?.hasPreviousChange){
      if(this.scrubberPointDetails?.status === 'noChange'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "scrubberPoint": Number(this.newScrubberPointVal?.newScrubberPoints),
        "scrubberPointEffectiveFrom":selectedNewScrubberPointsDateVal ? selectedNewScrubberPointsDateVal : upComingScrubberDate,
        "scrubberPointReason": this.scrubberPointsNewReason ? this.scrubberPointsNewReason : this.upComingScrubberReason
        }
        console.log("1")
      }
      if(this.scrubberPointDetails?.status === 'upcomingChange'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "scrubberPoint": Number(this.newScrubberPointVal?.newScrubberPoints),
        "scrubberPointEffectiveFrom": selectedUpcomingScrubberDate ? selectedUpcomingScrubberDate : upComingScrubberDate ,
        "scrubberPointReason": this.newUpcomingScrubberReason  ? this.newUpcomingScrubberReason  : this.upComingScrubberReason ,
        }
        console.log("2")
      }
      if(this.scrubberPointDetails?.status === 'pendingCalculation'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "scrubberPoint": Number(this.pendingCalcScrubberPointVal?.pendingCalcScrubberPoints),
        "scrubberPointEffectiveFrom":this.datePipe.transform(this.pendingCalcScrubberDate ,"yyyy-MM-dd") ,
        "scrubberPointReason": this.pendingCalcScrubberReason ,
        }
        console.log("3")
      }
    }else{
      this.updatePayload = {
      "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
      "scrubberPoint": Number(this.newScrubberPointVal?.newScrubberPoints),
      "scrubberPointEffectiveFrom":selectedNewScrubberPointsDateVal ? selectedNewScrubberPointsDateVal : upComingScrubberDate,
      "scrubberPointReason": this.scrubberPointsNewReason ? this.scrubberPointsNewReason : this.upComingScrubberReason
      }
      console.log("1")
    }
    console.log(this.updatePayload)
    this.vesselService.updateScrubberPointDetails(this.updatePayload).subscribe({
      next:(res:any)=>{
        console.log(res)
        this.updateScrubberPointsData = res?.data?.updateScrubberPointDetails?.data;
        console.log(this.updateScrubberPointsData)
        if(res?.data?.updateScrubberPointDetails?.statusCode === 200){
          this.getupdateScrubberPoints.emit(this.updateScrubberPointsData);
          this.discardScrubberSuccess = false;
          this.newScrubberPointForm.patchValue({
            newScrubberPoints: '',
            pendingCalcScrubberPoints:''
          });
          this.scrubberPointsNewReason = '';
          this.selectedNewScrubberPointsDateVal = null;
          this.pendingCalcScrubberDate = null;
            console.log(this.newScrubberPointForm)
            console.log(this.pendingCalcScrubberReason)
            console.log(this.pendingCalcScrubberDate)
          this.toasterService.openToast('Success', res?.data?.updateScrubberPointDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.updateScrubberPointDetails?.message);     
          this.errorScrubberPointLoaderEvent.emit();
          this.closeSidePanel();
        }
        
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorScrubberPointLoaderEvent.emit();
        this.closeSidePanel();
      }
    })
  }
 
  discardScrubberPoint(){
    this.openDiscardScrubberPoint = true;
    // this.openEditPoolPoints = false;
    this.openEditScrubberPoints = false;
  }
  discardScrubberPointChanges(){
    this.getScrubberPointLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isDiscarded": true
    }
    this.vesselService.discardScrubberPoints(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.discardScrubberPointDetails?.statusCode === 200){
          this.discardScrubberPointData = res?.data?.discardScrubberPointDetails?.data;
          if(this.discardScrubberPointData?.status !== 'upcomingChange'){
            this.showDiscardScrubberBanner = false;
          }
          this.discardScrubberSuccess = true;
          this.newScrubberPointForm.patchValue({
            newScrubberPoints: '',
            pendingCalcScrubberPoints:''
          });
          this.getupdateScrubberPoints.emit(this.discardScrubberPointData);
          this.toasterService.openToast('Success', res?.data?.discardScrubberPointDetails?.message);  
          this.scrubberPointsNewReason = '';
          this.pendingCalcScrubberReason = '';
          console.log(this.pendingCalcScrubberReason)
          console.log(this.pendingCalcScrubberDate)
        }else{
          this.toasterService.openToast('Error',res?.data?.discardScrubberPointDetails?.message);
          this.errorScrubberPointLoaderEvent.emit();
          this.closeSidePanel();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error',error);
        this.errorScrubberPointLoaderEvent.emit();
        this.closeSidePanel();
      }
    })
  }

  selectedPendingScrubberPointsDate(e:any){
    this.pendingCalcScrubberDate = e;
  }
  pendingScrubberfieldValue(e:any){
     console.log(e)
    this.pendingCalcScrubberReason = e;
    if(this.pendingCalcScrubberReason.length > 300){
      this.pendingCalcScrubberReasonError = true;
    }else{
      this.pendingCalcScrubberReasonError = false;
    }
  }
  revertScrubberPoints(){
    this.openRestoreScrubberPoint = true; 
    this.openEditScrubberPoints = false;
  }
  revertScrubberPointsChanges(){
     this.getScrubberPointLoaderEvent.emit();
     let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isRestoreToPreviousAction": true
    }
    this.vesselService.revertScrubberPointDetails(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.revertScrubberPointDetails?.statusCode === 200){
          this.revertScrubberPointData = res?.data?.revertScrubberPointDetails?.data
          this.getupdateScrubberPoints.emit(this.revertScrubberPointData);
          this.newScrubberPointForm.patchValue({
            newScrubberPoints: '',
            pendingCalcScrubberPoints:''
          });
          this.pendingCalcScrubberReason = '';
          this.toasterService.openToast('Success', res?.data?.revertScrubberPointDetails?.message);
          this.ediScrubberPointsVal = '';
        }else{
          this.toasterService.openToast('Error',res?.data?.revertScrubberPointDetails?.message);
          this.errorScrubberPointLoaderEvent.emit();
          this.closeSidePanel();
        }    
      },
      error:(error:any)=>{
         this.toasterService.openToast('Error',error);
         this.errorScrubberPointLoaderEvent.emit();
         this.closeSidePanel();
      }
    })
  }
  cancelScrubberPoint(){
    console.log("yes")
    this.newScrubberPointForm.patchValue({
      newScrubberPoints: '',
      pendingCalcScrubberPoints:''
    });
    this.ediScrubberPointsVal = '';
    this.callGetScrubberPointDetails();
  }
  closeSidePanel(){
    this.ediScrubberPointsVal = '';
    this.scrubberPointsReason = '';
    this.selectedScrubberPointsDateVal = null;
    this.selectedNewScrubberPointsDateVal = null;
    this.scrubberPointsNewReason = '';
    this.showScrubberPointsErrorMsg = false;
    this.showScrubberPointsPendingErrorMsg = false;
    this.newScrubberPointForm.patchValue({
      newScrubberPoints: '',
      pendingCalcScrubberPoints:''
    });
  }
  handleFocusOutScrubberPoints(e:any){
    this.showScrubberPointsErrorMsg = true;
  }
  handleFocusOutScrubberPointsPending(e:any){
    this.showScrubberPointsPendingErrorMsg = true;
  }

  isScrubberPointsInputError(controlName: 'newScrubberPoints' | 'pendingCalcScrubberPoints'): boolean {
    return !!this.getScrubberPointsInputErrorMessage(controlName);
  }

  getScrubberPointsInputErrorMessage(controlName: 'newScrubberPoints' | 'pendingCalcScrubberPoints'): string {
    const control = this.newScrubberPointForm?.get(controlName);
    if (!control?.invalid) {
      return '';
    }

    const showOnSubmit = controlName === 'newScrubberPoints'
      ? this.showScrubberPointsErrorMsg
      : this.showScrubberPointsPendingErrorMsg;

    if (control.hasError('pattern') && control.dirty) {
      return this.scrubberPointsPatternMessage;
    }

    if (control.hasError('required') && (control.dirty || (showOnSubmit && control.touched))) {
      return this.scrubberPointsRequiredMessages[controlName];
    }

    return '';
  }
}